// extracted by mini-css-extract-plugin
export var container = "_3q-0";
export var icon = "_3q-1";
export var text = "_3q-2";